import axios from "axios";
import * as rax from "retry-axios";
import { commonError, infoMessage } from "../utils/ErrorHandler/errorHandler";
import { isMobile } from "../utils/utils";
import { getDataserverUrl, isProd } from "../utils/envSelector";
import { Link, useHistory } from "react-router-dom";
import StorageManager from "../utils/StorageManager";
import { setInfo, addEvent } from "./Events/EventsApi";

// const baseurldataserver = "http://localhost:8080";
const baseurldataserver = getDataserverUrl();
// const baseurlcvserver = "https://dev.cv-server.anteia.co";
const baseurlcvserver = "https://services.anteia.co";

rax.attach();
export default class Api {
  constructor(setDeviceId) {
    this.token = "";
    this.setDeviceId = setDeviceId;
    this.history = useHistory();
    this.storage = new StorageManager();
  }

  getToken() {
    console.log("getting token");
    if (this.token && this.token !== "") {
      console.log("got token from memory");
      return this.token;
    } else {
      let token2 = this.storage.getToken();
      if (token2 !== "") {
        console.log("got token from storage");
        this.token = token2;
        return this.token;
      }
    }
  }

  // ------------------------------------------------
  // --------------QR FLOW STUFF---------------------
  // ------------------------------------------------

  //--------------------forceDataDone
  async forceDataDone() {
    console.log("Forcing DataDone...");
    let url = baseurldataserver + "/qrFlow/forceDatadone";
    let r = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    console.log(r);
  }

  // --------------SEND LINK SMS-----------------------
  async sendLink(phone) {
    console.log("sendLINK!!!!!");
    let code = this.getQueryStringVal("code");
    let req = { phone: phone, code: code };
    let url = baseurldataserver + "/qrFlow/sendLink";
    let result = await axios({
      method: "post",
      url: url,
      data: JSON.stringify(req),
      headers: {
        "Content-Type": "application/json",
      },
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
    });

    console.log(result);
    return result.status === 200;
  }
  // --------------SEND LINK EMAIL-----------------------
  async sendLinkEmail(email) {
    console.log("sendLINK!!!!!");
    let code = this.getQueryStringVal("code");
    let req = { email: email, code: code };
    let url = baseurldataserver + "/qrFlow/sendLinkEmail";
    let result = await axios({
      method: "post",
      url: url,
      data: JSON.stringify(req),
      headers: {
        "Content-Type": "application/json",
      },
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
    });

    console.log(result);
    return result.status === 200;
  }

  //--------------GET BACK URL-------------------------
  async getBackUrl() {
    console.log("DID OTP");
    let code = this.getQueryStringVal("code");
    let url = baseurldataserver + "/qrFlow/backUrl/" + code;
    let result = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
    });
    let jsonResponse = result.data;
    return jsonResponse.url;
  }

  // --------------CREATE CODE-----------------------
  async createCode() {
    console.log("CreateCode");
    let code = this.getQueryStringVal("code");
    let otpReq = { code: code };
    let url = baseurldataserver + "/qrFlow/createCode";
    let result = await axios({
      method: "post",
      url: url,
      data: JSON.stringify(otpReq),
      headers: {
        "Content-Type": "application/json",
      },
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
    });

    console.log(result);
    return result.status === 200;
  }

  // --------------ASSIGN REG CODE-----------------------
  async assignReg() {
    console.log("Assign Reg");
    let code = this.getQueryStringVal("code");
    let otpReq = { code: code };
    let url = baseurldataserver + "/qrFlow/assignReg";
    let result = await axios({
      method: "post",
      url: url,
      data: JSON.stringify(otpReq),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
    });

    console.log(result);
    return result.status === 200;
  }

  // --------------CHECK DONE-----------------------
  async checkDone() {
    console.log("CheckDone");
    let code = this.getQueryStringVal("code");
    let url = baseurldataserver + "/qrFlow/checkDone/" + code;
    let result = await axios({
      method: "get",
      url: url,
      headers: {
        "Content-Type": "application/json",
      },
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
    });

    console.log(result);
    return result.data;
  }
  // --------------IS QR CODED REG CODE-----------------------
  isQr() {
    if (!this.qr) {
      let qr = this.getQueryStringVal("qr");
      console.log(qr);
      console.log("QRRR");
      this.qr = qr !== null;
      console.log(this.qr);
      return this.qr;
    } else {
      console.log(this.qr);
      console.log("QRRR");
      return this.qr;
    }
  }

  // --------------VERIFY SMS CODE-------------------

  async otpMobile(opt) {
    if (opt !== "") {
      let otpReq = { code: opt };

      let url = baseurldataserver + "/otp/confirmOtpMobile";
      let result = await axios({
        method: "post",
        url: url,
        data: JSON.stringify(otpReq),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
        raxConfig: {
          retry: 3, // number of retry when facing 4xx or 5xx
          noResponseRetries: 3, // number of retry when facing connection error
          onRetryAttempt: (err) => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
          },
        },
      });

      return result.data;
    }
  }

  // --------------VERIFY LOCATION-------------------

  GeolocationPage(
    latitude,
    longitude,
    address,
    locality,
    administrativearealevel2,
    state,
    country,
    postalcode
  ) {
    if (latitude !== "" && longitude !== "") {
      let dataUbication = {
        latitudeUser: latitude,
        longitudeUser: longitude,
        address: encodeURIComponent(address),
        locality: locality,
        administrativearealevel2: administrativearealevel2,
        state: state,
        country: country,
        postalcode: postalcode,
      };
      let url = baseurldataserver + "/registerFlow/addUserLocation";
      axios({
        method: "post",
        url: url,
        data: JSON.stringify(dataUbication),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      })
        .then((response) => {
          console.log("response geoloc!");
          console.log(response);
          return response.data;
        })
        .catch((error) => console.log(error.response, "ERROR"));
    }
  }

  //-----DID normal OTP---------
  async didOtpNormal() {
    console.log("DID OTP");
    let url = baseurldataserver + "/otp/didOtp";
    let otpResult = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    let otpJson = otpResult.data;
    if (!otpJson.confirmed) {
      infoMessage("¡No has verificado tu celular!");
      console.log(otpJson);
      return false;
    }
    console.log("OTP CONFIRMADO");
    return true;
  }

  //--------------WRONG DATA URL-------------------
  async getWrongDataUrl() {
    console.log("DID OTP");
    let url = baseurldataserver + "/registerFlow/wrongDataUrl";
    let result = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    let jsonResponse = result.data;
    return jsonResponse.url;
  }
  // --------------OTP EMAIL-------------------
  async didOtpAndMail() {
    console.log("DID OTP");
    let url = baseurldataserver + "/otp/didOtp";
    let emailUrl = baseurldataserver + "/otp/didEmail";
    let emailResponse = await axios({
      method: "get",
      url: emailUrl,
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    let emailJson = emailResponse.data;
    if (!emailJson.confirmed) {
      console.log(emailJson);
      infoMessage("¡No has verificado tu correo!");
      return false;
    }
    console.log("EMAIL CONFIRMADO");
    return true;
  }

  async didEmail() {
    console.log("DID OTP");
    let emailUrl = baseurldataserver + "/otp/didEmail";
    let emailResponse = await axios({
      method: "get",
      url: emailUrl,
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    let emailJson = emailResponse.data;
    if (!emailJson.confirmed) {
      console.log(emailJson);
      // infoMessage("No has verificado tu correo!");
      return false;
    }
    console.log("EMAIL CONFIRMADO");
    return true;
  }

  async confirmotp(updateubication) {
    let locationUrl = baseurldataserver + "/registerFlow/userLocation";
    let locationResponse = await axios({
      method: "get",
      url: locationUrl,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    let locationJson = locationResponse.data;

    let dire;
    let arrayDeCadenas = locationJson.address.split(",");

    dire = arrayDeCadenas[0];

    updateubication({
      direccion: dire,
      ciudad: locationJson.state,
      pais: locationJson.country,
      latitud: locationJson.lat,
      longitud: locationJson.lon,
    });
    return locationJson;
  }

  sendInitUser(init) {
    if (init !== "") {
      let code = { nit: init };
      let url = baseurldataserver + "/registerFlow/addNit";
      axios({
        method: "post",
        url: url,
        raxConfig: {
          retry: 3, // number of retry when facing 4xx or 5xx
          noResponseRetries: 3, // number of retry when facing connection error
          onRetryAttempt: (err) => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
          },
        },
        data: JSON.stringify(code),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      })
        .then((response3) => {
          console.log(response3, "AWESOME POST FROM CODE NIT");
        })
        .catch((error) => {
          console.log(error, "ERROR JURIDICA");
        });
    }
  }

  //--------------setRut---------------------------

  setRut(rut) {
    if (rut !== "") {
      let code = { rut: rut };
      let url = baseurldataserver + "/registerFlow/addRut";
      axios({
        method: "post",
        url: url,
        raxConfig: {
          retry: 3, // number of retry when facing 4xx or 5xx
          noResponseRetries: 3, // number of retry when facing connection error
          onRetryAttempt: (err) => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
          },
        },
        data: JSON.stringify(code),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      })
        .then((response3) => {
          console.log(response3, "AWESOME POST FROM CODE RUT");
        })
        .catch((error) => {
          console.log(error, "ERROR AddRut");
        });
    }
  }

  //Execute CV
  async executeCv() {
    console.log("execute CV!!!!!!!!!!");
    let url = baseurldataserver + "/registerFlow/executeCv";
    let res = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
  }

  //----------SendEmailNew--------------------
  async sendEmailNew() {
    console.log("sendEmail");
    let emailUrl = baseurldataserver + "/otp/sendEmailNew";
    try {
      let emailResponse = await axios({
        method: "get",
        url: emailUrl,
        headers: {
          Authorization: "Bearer " + this.getToken(),
        },
      });
      console.log("EMAIL Enviado");
      addEvent("EMAIL_SENT", {}, {}, "interaction");
      if (emailResponse.status !== 200 && emailResponse.status !== 201) {
        addEvent(
          "EMAIL_ERROR",
          { error: emailResponse.data, status: emailResponse.status },
          {},
          "error"
        );
      }
      return true;
    } catch (err) {
      addEvent("EMAIL_ERROR", { error: err.message }, {}, "error");
    }
  }

  //----------ConfirmEmailNew--------------------
  async confirmEmailNew(code) {
    this.storage.setGenericString("false", "agFinal");
    console.log("confirmEmailNew");
    let emailUrl = baseurldataserver + "/otp/confirmEmailNew?code=" + code;
    let emailResponse = await axios({
      method: "get",
      url: emailUrl,
    }).catch((e) => {
      console.log(e);
    });
    this.token = emailResponse.data.token;
    this.storage.setToken(this.token);
    console.log("EMAIL Confirmado");
    return true;
  }

  //----------SendOtpGps--------------------
  async sendOtpGps() {
    console.log("sendOtpGps");
    let emailUrl = baseurldataserver + "/otp/sendOtp";
    let emailResponse = await axios({
      method: "post",
      url: emailUrl,
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    console.log("SMS Enviado");
    return true;
  }

  //----------SendOtpNormal--------------------
  async sendOtp() {
    console.log("Send OTP");
    let emailUrl = baseurldataserver + "/otp/sendOtpMobile";
    try {
      let emailResponse = await axios({
        method: "post",
        url: emailUrl,
        headers: {
          Authorization: "Bearer " + this.getToken(),
        },
      });
      if (emailResponse.status === 200) {
        addEvent("OTP_SENT", {}, {}, "interaction");
      } else {
        addEvent(
          "OTP_ERROR",
          { error: `status code: ${emailResponse.status}` },
          {},
          "interaction"
        );
      }
    } catch (err) {
      addEvent("OTP_ERROR", { error: err.message }, {}, "error");
    }
    console.log("SMS Enviado");
    return true;
  }

  //----------------ModifyEmail----------------
  async modifyEmail(email) {
    let url = baseurldataserver + "/registerFlow/modifyEmail";
    let req = {
      email: email,
    };
    return axios({
      method: "post",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      data: JSON.stringify(req),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
  }

  //----------------ModifyEmail----------------
  async modifyPhone(phone) {
    let url = baseurldataserver + "/registerFlow/modifyPhone";
    let req = {
      phone: phone,
    };
    return axios({
      method: "post",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      data: JSON.stringify(req),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
  }

  //----------Log--------------------
  async log(data, method) {
    try {
      let url = baseurldataserver + "/logger";
      let req = {
        data: "method: " + method + ", data: " + data,
      };
      axios({
        method: "post",
        url: url,
        raxConfig: {
          retry: 3, // number of retry when facing 4xx or 5xx
          noResponseRetries: 3, // number of retry when facing connection error
          onRetryAttempt: (err) => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
          },
        },
        data: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      }).catch((e) => {});
    } catch (e) {}
  }

  async final(gotoClose, gotoAgentFinal) {
    let url = baseurldataserver + "/registerFlow/verifyRegistration";
    let res1 = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
    console.log("verifyRegistration");
    console.log(res1.data, "RES1 DATA");
    url = baseurldataserver + "/registerFlow/unifiedChecks";
    if (res1.status !== 200) return;
    let responseChecks = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
    console.log("unifiedChecks");
    console.log(responseChecks.data);
    let pasaUnifiedChecks = this.handleUnifiedChecks(responseChecks.data);
    //Handle wrong unified checks
    if (!pasaUnifiedChecks) {
      infoMessage(
        "Una de las fases de verificación no fue exitosa, nos pondremos en contacto contigo."
      ).then(() => {
        infoMessage("Ya puedes cerrar esta ventana");
      });
    }
    //verify unifiedChecksOk
    let reg = res1.data;
    let project = this.storage.getProject();
    if (
      project &&
      project.extraConfig &&
      project.extraConfig.sendToAgentOnFinal === true
    ) {
      console.log("checking if agentOnFinal");
      console.log(reg);
      let agFinal = this.storage.getGenericString("agFinal");
      if (reg.unifiedChecksOk === false && agFinal === "false") {
        gotoAgentFinal();
        this.storage.setGenericString("true", "agFinal");
        return;
      }
    }
    url = baseurldataserver + "/registerFlow/executeWebHook";
    if (res1.status === 200 && pasaUnifiedChecks) {
      try {
        let res2 = await axios({
          method: "get",
          url: url,
          raxConfig: {
            retry: 3, // number of retry when facing 4xx or 5xx
            noResponseRetries: 3, // number of retry when facing connection error
            onRetryAttempt: (err) => {
              const cfg = rax.getConfig(err);
              console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
            },
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.getToken(),
          },
        });
      } catch (e) {}
      if (!this.isQr()) {
        window.location = res1.data.redirectionUrl;
      } else {
        // this.gotoCloseWindowScreen();
        gotoClose();
        // this.history.push("/closeWindow");
        // window.location.href = 'https://api.anteia.co/final';
        //creo que ya esta(?)
      }
    }
  }
  //QUITAR PARA DEV
  handleUnifiedChecks(checks) {
    if (!isProd()) return true;
    return true;
    if (checks.listsCheck.active && !checks.listsCheck.result) {
      return false;
    } else {
      return true;
    }
  }

  async sendPhoneLink(matiId, needsFace = false) {
    console.log("SendPhoneLink");
    let data = {
      matiId: matiId,
      needsFace: needsFace,
    };
    console.log("Sending Link for extra phone photo");
    console.log(data);
    let url = baseurldataserver + "/phonePhoto";
    let res = await axios({
      method: "post",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      data: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
  }

  async checkPhonePhoto() {
    console.log("Checking phone photo...");
    let url = baseurldataserver + "/phonePhoto/check";
    let res = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
    console.log(res);
    return res.data.confirmed;
  }

  initialRegistration(code, proj, setToken, setRegistrationId) {
    console.log("INITIAL REGISTRATIONOOOOOOOOO");
    let data = { projectId: proj.id, code: code };
    console.log(data);
    let url = baseurldataserver + "/registerFlow/initialRegistration";
    return axios({
      method: "post",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      data: JSON.stringify(data),

      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((resp) => {
        let response = resp.data;
        console.log("RegistraitonID from response: " + response.registrationId);
        setRegistrationId(response.registrationId);
        console.log("RegistraitonID from response: " + response.registrationId);
        console.log(response);
        console.log(response.userToken);
        setToken(response.userToken);
        this.token = response.userToken;
        this.storage.setToken(response.userToken);
        this.addUserDeviceInformation(response.userToken);
        setInfo(response.registrationId, proj.clientId, proj.id);
        addEvent("INITIAL_REG", {}, {}, "interaction");
        if (this.isQr()) {
          this.assignReg();
        }
      })
      .catch((e) => alert(e));
  }
  /**
   *
   * @param {string} nit
   */
  async addNit(nit) {
    console.log("Add NIT: " + nit);
    let postUrl = baseurldataserver + "/registerFlow/addNit";
    let body = {
      nit: nit,
    };
    try {
      let result = await axios({
        method: "post",
        url: postUrl,
        raxConfig: {
          retry: 3, // number of retry when facing 4xx or 5xx
          noResponseRetries: 3, // number of retry when facing connection error
          onRetryAttempt: (err) => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
          },
        },
        data: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      });
      if (!(result.status === 200 || result.status === 201)) {
        alert("Error enviando NIT");
      }
    } catch (e) {
      commonError("Error enviando el NIT");
    }
  }
  /**
   *
   * @param {*} id
   */
  async addUserId(id, nombre, apellido) {
    console.log("Add User Id: " + id);
    let postUrl = baseurldataserver + "/registerFlow/addUserIdentification";
    let body = {
      identification: id,
      identificationType: "CedulaCiudadania",
      country: "colombia",
      expDate: "",
      birthPlace: "",
      height: "",
      rh: "",
      sex: "",
      birthDate: "",
      pdf417info: "",
      accuracy: "",
      name: nombre,
      lastName: apellido,
    };
    let result = await axios({
      method: "post",
      url: postUrl,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      data: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    });
    if (!(result.status === 200 || result.status === 201)) {
      alert("Error enviando NIT");
    }
  }

  async addUserInitialInformation(cc, lastName, email, phone, docType, name) {
    let postUrl = baseurldataserver + "/registerFlow/addInitialInformation";
    let body = {
      lastName: lastName,
      cellphone: phone,
      email: email,
      identification: cc,
      documentType: docType,
      name: name,
    };
    console.log("Initial Info");
    console.log(body);
    try {
      let result = await axios({
        method: "post",
        url: postUrl,
        raxConfig: {
          retry: 3, // number of retry when facing 4xx or 5xx
          noResponseRetries: 3, // number of retry when facing connection error
          onRetryAttempt: (err) => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
          },
        },
        data: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      });
      if (!(result.status === 200 || result.status === 201)) {
        commonError("Error enviando información inicial: " + result.status);
      }
      addEvent("INITIAL_DATA", {}, {}, "interaction");
    } catch (e) {
      commonError("Error enviando información inicial: " + e);
    }
  }

  async addUserDeviceInformation() {
    console.log("ADD USER DEVICE INFO with TOKEN: " + this.getToken());
    let ip = "BLOCKED";
    try {
      let response = await fetch("https://api.ipify.org/");
      ip = await response.text();
    } catch (e) {
      addEvent("DEVICEID_ERROR", { error: e.message }, {}, "error");
    }

    let url = baseurldataserver + "/registerFlow/addDeviceInfo";
    let deviceID = "";
    if (MediaDeviceInfo) deviceID = MediaDeviceInfo.deviceId;
    let dataf = {
      os: window.navigator.userAgent,
      deviceId: deviceID,
      // screenHeigh: document.documentElement.clientHeight,
      screenHeigh: window.screen.height,
      // screenWidth: document.documentElement.clientWidth,
      screenWidth: window.screen.width,
      trusted: true,
      type: "Web",
      ip: ip,
      numCpus: window.navigator.hardwareConcurrency,
    };
    this.setDeviceId(dataf);
    console.log(dataf);
    console.log("TOKEN: " + this.getToken());
    fetch(url, {
      method: "POST",
      body: JSON.stringify(dataf),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    })
      .catch((error) => {
        addEvent("DEVICEID_ERROR", { error: error.message }, {}, "error");
      })
      .then((res2) => res2.json())
      .then((response2) => {
        addEvent("DEVICEID_SET", {}, {}, "interaction");
        console.log(response2);
      });
  }

  async checkLists() {
    console.log("Checking Lists...");
    let url = baseurldataserver + "/registerFlow/executeLists";
    try {
      let r = await axios({
        method: "get",
        url: url,
        raxConfig: {
          retry: 3, // number of retry when facing 4xx or 5xx
          noResponseRetries: 3, // number of retry when facing connection error
          onRetryAttempt: (err) => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
          },
        },
        headers: {
          Authorization: "Bearer " + this.getToken(),
        },
      });
      console.log("Checking Lists... DONE!");
      console.log(r);
    } catch (e) {
      console.log(e);
    }
  }

  /**
   *
   * @returns the preloaded data
   */
  async getPreloadedData() {
    const code = this.getQueryStringVal("code");
    const url =
      baseurldataserver + "/registerFlow/getPreloadedData?code=" + code;
    console.log(url);
    const result = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    }).catch((e) => {
      console.log(e);
      commonError("Error cargando datos");
      return;
    });
    if (!(result.status === 200 || result.status === 201)) {
      commonError("Error cargando datos: " + result.status);
      return;
    }
    return result.data;
  }

  /**
   *
   * @returns true if data done, false if not done
   */
  async getDataDone() {
    // if (!isProd()) {
    //   // await this.forceDataDone();
    //   return true;
    // }
    // await this.forceDataDone();
    // return true;
    // if (!this.token) return;
    const code = this.getQueryStringVal("code");
    const url = baseurldataserver + "/registerFlow/dataDone";
    console.log(url);
    const result = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    if (!(result.status === 200 || result.status === 201)) {
      commonError("Error cargando datos: " + result.status);
      return;
    }
    let jsonResponse = result.data;
    return jsonResponse.dataDone;
  }

  /**
   *
   * @returns the checks
   */
  async getChecks() {
    if (!this.token) return;
    const code = this.getQueryStringVal("code");
    const url = baseurldataserver + "/registerFlow/unifiedChecks";
    console.log(url);
    const result = await axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        Authorization: "Bearer " + this.getToken(),
      },
    });
    if (!(result.status === 200 || result.status === 201)) {
      commonError("Error cargando datos: " + result.status);
      return;
    }
    return result.data;
  }

  async checkFacematch() {
    console.log("CHECKING FACEMAAAAAAAAAAAAAAAAATCH");
    let encToken = this.getToken();
    let decToken = this.parseJwt(encToken);
    let regId = decToken.registrationId;
    console.log("regId: " + regId);
    let url = baseurldataserver + "/savePicture/comparar/" + regId;
    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      });
      let data = resp.data;
      console.log(data);
      return data.Result;
    } catch (e) {
      console.log(e);
      return false;
    }
  }
  /**
   * GETS auth request by code
   * @param } code
   * @returns
   */
  async getAuthRequest(code) {
    console.log("GettingAuthRequest: " + code);
    let url = baseurldataserver + "/authProcess/byCode/" + code;

    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async setAuthResult(code, score) {
    let req = {
      result: score,
    };
    console.log("SettingResult");
    console.log(req);
    let url = baseurldataserver + "/authProcess/setResult/" + code;
    try {
      let result = await axios({
        method: "post",
        url: url,
        raxConfig: {
          retry: 3, // number of retry when facing 4xx or 5xx
          noResponseRetries: 3, // number of retry when facing connection error
          onRetryAttempt: (err) => {
            const cfg = rax.getConfig(err);
            console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
          },
        },
        data: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!(result.status === 200 || result.status === 201)) {
        commonError("Error enviando setResult: " + result.status);
      }
    } catch (e) {
      commonError("Error enviando setREsult: " + e);
    }
  }

  /**
   * gets the brand config
   * @param {string} code
   */
  async getBrandConfig(code) {
    console.log("Getting BrandConfig: " + code);
    let url = baseurldataserver + "/brandConfig/byCode/" + code;

    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async validateCode(code) {
    console.log("validating code: " + code);
    let url = baseurldataserver + "/registerFlow/validateCode?code=" + code;
    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  /**
   * gets the brand config
   * @param {string} code
   */
  async getBrandConfigAuth(code) {
    console.log("Getting BrandConfig: " + code);
    let url = baseurldataserver + "/brandConfig/byAuthCode/" + code;

    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  getQuestions(setQuestions) {
    let url = baseurldataserver + "/experian/questions";
    return axios({
      method: "get",
      url: url,
      raxConfig: {
        retry: 3, // number of retry when facing 4xx or 5xx
        noResponseRetries: 3, // number of retry when facing connection error
        onRetryAttempt: (err) => {
          const cfg = rax.getConfig(err);
          console.log(`Retry attempt #${cfg.currentRetryAttempt}`); // track current trial
        },
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getToken(),
      },
    })
      .then((response) => {
        console.log("getQuestions");
        console.log(response.data);

        setQuestions(response.data);
      })
      .catch((e) => alert(e));
  }

  async getProject() {
    console.log("GettingPRoject");
    let url = baseurldataserver + "/registerFlow/getProject";

    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async getRegistrationData() {
    console.log("GettingRegistrationData");
    let url = baseurldataserver + "/registerFlow/status";
    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      });
      let data = resp.data;

      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async confirmData(data) {
    console.log("confirmingData");
    let url = baseurldataserver + "/registerFlow/confirmData";
    try {
      let resp = await axios({
        method: "post",
        url: url,
        data: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      });
      let data2 = resp.data;
      console.log(data2);
      return data2;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async checkPhoneEmail(email2, phone2) {
    console.log("Checking email and phone");
    let url = baseurldataserver + "/registerFlow/checkEmailPhoneExists";
    let data2 = {
      email: email2,
      phone: phone2,
    };
    console.log(data2);
    try {
      let resp = await axios({
        method: "post",
        url: url,
        data: JSON.stringify(data2),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async getAuthRedirection(code) {
    console.log("GettingAuthRedirection: " + code);

    try {
      let url = baseurldataserver + "/authProcess/getRedirection/" + code;
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let data = resp.data;
      return data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async checkMaxTries(documentNumber) {
    console.log("CheckMaxTries");
    let url = baseurldataserver + "/registerFlow/checkMaxTries";
    let req = {
      documentNumber: documentNumber,
    };
    console.log(req);
    try {
      let resp = await axios({
        method: "post",
        url: url,
        data: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.getToken(),
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  async getProjectByCode(code) {
    console.log("getProjectByCode");
    let url = baseurldataserver + "/registerFlow/getProjectByCode?code=" + code;
    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async getProjectByAuthCode(code) {
    console.log("getProjectByAuthCode");
    let url =
      baseurldataserver + "/authProcess/getProjectByAuthCode?code=" + code;
    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      let data = resp.data;
      console.log(data);
      return data;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  async sendSmsAuth(code, forceBackup) {
    console.log("sendSms");
    let url =
      baseurldataserver +
      "/authProcess/sendSms?code=" +
      code +
      "&forceBackup=" +
      forceBackup;
    try {
      let resp = await axios({
        method: "get",
        url: url,
      });
      console.log(resp);
    } catch (e) {
      console.log(e);
    }
  }

  async sendEmailAuth(code, forceBackup) {
    console.log("sendEmail");
    let url =
      baseurldataserver +
      "/authProcess/sendEmail?code=" +
      code +
      "&forceBackup=" +
      forceBackup;
    try {
      let resp = await axios({
        method: "get",
        url: url,
      });
      console.log(resp);
    } catch (e) {
      console.log(e);
    }
  }

  async spoolUp() {
    console.log("Spooling Up!");
    let url = baseurldataserver + "/savePicture/spoolUp";
    try {
      let resp = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log(resp);
    } catch (e) {
      console.log(e);
    }
  }

  getQuery = () => {
    if (typeof window !== "undefined") {
      return new URLSearchParams(window.location.search);
    }
    return new URLSearchParams();
  };

  getQueryStringVal = (key) => {
    return this.getQuery().get(key);
  };

  parseJwt(token) {
    let base64Url = token.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }
}
